import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useServerData } from '@xingternal/hops';

import { useRecentlyClaimedCompanies } from '@/hooks/useRecentlyClaimedCompanies';
import { useTrackPage } from '@/hooks/useTrackPage';

import { CompanyLoggedout } from '@/components/CompanyLoggedout';
import { usePagination } from '@/hooks/usePagination';
import { pagesTrackingName } from '@/utils/tracking';
import { scrollToTop } from '@/utils';
import { LOGGED_IN_CARDS_PER_PAGE, LOGGED_OUT_CARDS_PER_PAGE } from '@/config';
import { Company } from '@/types/graphql-types';
import styles from './RecentlyClaimedCompanies.css';

const RecentlyClaimedCompanies = () => {
  const { authenticated } = useServerData();
  const intl = useIntl();
  useEffect(() => scrollToTop(), []);

  const limit = authenticated
    ? LOGGED_IN_CARDS_PER_PAGE
    : LOGGED_OUT_CARDS_PER_PAGE;

  const { changePage, activePage } = usePagination();

  const { data, loading, error } = useRecentlyClaimedCompanies({
    limit,
    offset: limit * (activePage - 1),
  });

  useTrackPage({ pageName: pagesTrackingName.recentlyClaimed });
  const { collection, total } = data?.companiesRecentlyClaimed ?? {};

  return (
    <CompanyLoggedout
      companies={collection?.map((item) => item?.company as Company)}
      total={total}
      headerText={intl.formatMessage({
        id: 'CP_100_LATELY_BOUGHT_CPS_HEADLINE_NEW',
      })}
      authenticated={authenticated}
      limit={limit}
      activePage={activePage}
      changePage={changePage}
      loading={loading}
      error={error}
      styles={styles}
    />
  );
};

export { RecentlyClaimedCompanies };
